export const TAG_TYPES = {
  HAS_STOCK: 'hasStock',
  IS_CERTIFIED: 'success',
  IS_URGENT: 'isUrgent',
  IS_FINANCED: 'isFinanced',
  PUBLISHED_DATE: 'publishedDate'
}

export const BADGES_TYPES = {
  IS_CERTIFIED: 'success',
  HAS_STOCK: 'aquaWithoutHover',
  ACTUALIDAD: 'teal',
  IS_FINANCED: 'blue',
  IS_URGENT: 'bloodOrange',
  MULTIPROVINCE: 'aquaWithoutHover',
  INFO: 'gray'
}

export const TARGET_BUYER_TAB_INDEX = {
  PRIVATES: 1,
  BUSINESS: 2
}

// ff_web_lead_experience_whatsapp_label_buttons — ABC: `a` exige login para contactar por WhatsApp,
// `c` mueve la etiqueta del CTA de WhatsApp al de llamada
export const FF_WHATSAPP_LEAD_EXPERIENCE = 'ff_web_lead_experience_whatsapp_label_buttons'
export const WHATSAPP_LEAD_EXPERIENCE_VARIANTS = {
  LOGIN_REQUIRED: 'a',
  NO_LOGIN: 'b',
  NO_LOGIN_WITH_PHONE_CALL_LABEL: 'c'
}
